<template>
    <div class="register-container">
        <div class="register-content">
            <div class="register-form clearfix">
                <div class="register-back">
                    <span @click="backHandle">
                        <a-icon type="left" />返回
                    </span>
                </div>
                <div class="register-logo">
                    <img class="register-logo_img" :src="logo" alt="">
                    <div>
                        <span class="register-name">幼学记</span>
                        <span class="register-des">家校链接新方式</span>
                    </div>
                </div>
                <a-input class="register-input" v-model="loginForm.name" placeholder="请输入姓名" />
                <a-input class="register-input" v-model="loginForm.mobile" placeholder="请输入手机号" />
                <a-input class="register-input" v-model="loginForm.verification_code" placeholder="请输入验证码" />

                <div class="register-verify" @click="getVerifyHandel">{{ isSending ? time : "发送验证码" }}</div>
                <a-button class="submit-btn register-btn" @click="registerHandle">确定</a-button>
                <div class="register-tips">
                    登录注册即表示同意 <span><span @click="viewAgreement('user')">用户协议</span> 、<span
                            @click="viewAgreement('private')">隐私协议</span></span>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import { mapGetters } from "vuex";
import logo from "@/assets/images/logo.png";
import userService from "@/api/userService";

export default {
    name: "register",
    components: {},
    data() {
        return {
            logo,
            loginForm: {
                mobile: undefined,
                verification_code: undefined,
                name: undefined,
            },
            isVerifyLogin: true,
            isSending: false,
            timer: null,
            time: 60,
            messageId: null,
        }
    },
	computed: {
		...mapGetters(["hasTeacherRole", "isManager"]),
	},

    methods: {
        backHandle() {
            this.$router.back();
        },

        getVerifyHandel() {
            if (!this.loginForm.mobile || this.loginForm.mobile.trim().length !== 11) {
                this.$message.warning("请输入合法的手机号");
                return;
            }
            if (this.isSending) return;
            this.isSending = true;
            userService.getVerifyCodeService({ mobile: this.loginForm.mobile.trim() }).then(res => {
                this.messageId = res.message_id;
                this.timeCountHandle();
            }).catch(() => {
                this.isSending = false;
            });
        },


        timeCountHandle() {
            this.timer = setTimeout(() => {
                let time = this.time - 1;
                if (time < 1) {
                    clearTimeout(this.timer);
                    this.isSending = false;
                    this.time = 60;
                } else {
                    this.time = time;
                    this.timeCountHandle();
                }
            }, 1000);
        },

        registerHandle() {
            const { mobile, verification_code, name } = this.loginForm;
            if (!mobile || mobile.trim().length !== 11) {
                this.$message.warning("请输入合法的手机号");
                return;
            }

            if (!name || !name.trim().length) {
                this.$message.warning("请输入姓名");
                return;
            }

            if (!this.messageId) {
                this.$message.warning("请先获取验证码");
                return;
            }

            if (!verification_code || verification_code.trim().length !== 6) {
                this.$message.warning("请输入合法的验证码");
                return;
            }

            userService.registerService({
                mobile: mobile.trim(),
                name: name.trim(),
                verification_code: verification_code.trim(),
                verification_message_id: this.messageId,
            }).then((res) => {
                this.$store.commit("setAccessToken", res.access_token)
                this.$store.dispatch("getUserInfoService");
                this.getTeacherInfo();
            }).catch((err) => {
                this.isSending = false;
                const constraint = err && err.response && err.response.data && err.response.data.constraint;
                const error = err && err.response && err.response.data && err.response.data.error;
                const operator = err && err.response && err.response.data && err.response.data.operator;
                const fields = err && err.response && err.response.data && err.response.data.fields;

                if (error === "Not Allowed" && operator === "code_verification") {
                    this.$message.error("您输入的验证码异常，请输入正确的验证码");
                } else if (constraint == "Duplicated Entity" && error == "Duplicated Entity Error" && fields.includes("mobile")) {
                    this.$message.error("您的手机号已注册，请直接登录");
                } else {
                    this.$message.error("注册异常");
                }
            });
        },

        getTeacherInfo() {
            this.$store.dispatch("getTeacherInfoMineListService").then((res) => {
                if (!res.length) {
                    this.$router.push({ name: "notPermission" });
                } else if (this.isManager || this.hasTeacherRole) {
                    this.$router.push({ name: "school" });
                } else {
                    this.$router.push({ name: "external" });
                }
            }).catch(() => {
                this.isSending = false;
            });
        },

        viewAgreement(type) {
            if (type === "user") {
                window.open("https://www.feixuehz.com/agreement.html", "_blank");
            } else {
                window.open("https://www.feixuehz.com/privacy.html", "_blank");
            }
        }
    }
}
</script>

<style lang="less" scoped>
.register {
    &-container {
        position: relative;
        height: 100vh;
        background: url("../../assets/images/login_bg.png") no-repeat 0 0;
        background-size: 100% 100%;
    }

    &-content {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1070px;
        height: 658px;
        padding-left: 534px;
        border-radius: 16px;
        background: #FFFFFF url("../../assets/images/login_content_bg.png") no-repeat 33px 125px;
        background-size: 447px 407px;
    }

    &-form {
        position: relative;
        width: 437px;
        height: 544px;
        margin-top: 54px;
        padding: 0 35px;
        border-radius: 4px;
        opacity: 1;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    }

    &-back {
        display: flex;
        flex-flow: nowrap row;
        align-items: center;
        height: 20px;
        margin: 20px 0 20px -20px;
        font-size: 14px;
        color: #3D3D3D;
        cursor: pointer;
    }

    &-logo {
        display: flex;
        flex-flow: nowrap row;
        align-items: center;
        justify-content: center;
        margin-bottom: 54px;

        &_img {
            width: 63px;
            margin: 5px 10px 0 0;
        }
    }

    &-name {
        display: block;
        height: 42px;
        margin-bottom: 5px;
        font-size: 32px;
        color: #343C6A;
    }

    &-des {
        display: block;
        height: 20px;
        font-size: 14px;
        color: #343C6A;
    }

    &-input {
        display: block;
        margin: 0 auto 20px;
        width: 368px;
        height: 56px;
        border-radius: 8px;
        border: 1px solid #D6D6D6;
    }

    &-verify {
        position: absolute;
        right: 35px;
        top: 335px;
        width: 100px;
        height: 56px;
        line-height: 56px;
        cursor: pointer;
        color: #01ACFC;
        text-align: center;
    }

    &-tips {
        margin-top: 10px;
        font-size: 14px;
        cursor: pointer;
        text-align: center;
        color: #3D3D3D;

        span {
            color: #01ACFC;
            cursor: pointer;
        }
    }

    &-btn {
        margin: 50px auto 0 !important;
    }
}
</style>
    